import DataViewerCardModel from "../../dashboard/DataViewerCardModel.js";
import DataViewerModel from "../../DataViewerModel.js";
import HistoryViewModel from "../../history/models/HistoryViewModel.js";
export default function convert(old, opts) {
  const {
    settingsPath,
    usedSettingsPath,
    getSettingsAt
  } = opts;
  const table = getSettingsAt(`${settingsPath}.table`);
  const list = getSettingsAt(`${settingsPath}.list`);
  usedSettingsPath.add(`${settingsPath}.table`);
  usedSettingsPath.add(`${settingsPath}.list`);
  const settings = HistoryViewModel.create({
    dataViewers: [DataViewerModel.create('molten.HistoryListSupport', list), DataViewerModel.create('molten.HistoryTableSupport', table)],
    breakpoints: ['minWidth']
  });
  const r = DataViewerCardModel.create(DataViewerModel.create('molten.History', settings));
  if (old?.height) {
    r.height = old.height;
  }
  return r;
}
convert.TYPE = 'dashboard.HistoryCard';